import React, { Fragment, useState } from 'react';
import { SeoOfferData } from '../../pages/runtime-typechecker';
import './OfferDropdown.css';

type OfferDropdown = {
  seoOfferData: SeoOfferData[];
  setOpenOffersDropdown: (boolean) => void;
};

const OfferDropdown = ({
  seoOfferData,
  setOpenOffersDropdown
}: OfferDropdown) => {
  const [selectedOffer, setSelectedOffer] = useState('');

  return (
    <Fragment>
      <div className="dropdownContainer">
        <div className="mainHeader">More Deals for you</div>
        <div className="subHeader">More Discounts for your bus</div>
        <div className="hideBtn" onClick={() => setOpenOffersDropdown(false)}>
          Hide
          <span className="upArrow" />
        </div>
        <div className="displayFlex">
          {seoOfferData?.map(offer => (
            <Offer
              offer={offer}
              selectedOffer={selectedOffer}
              setSelectedOffer={setSelectedOffer}
            />
          ))}
        </div>
      </div>
      <div
        className="listBackdrop"
        onClick={() => setOpenOffersDropdown(false)}
      >
        &nbsp;
      </div>
    </Fragment>
  );
};

export default OfferDropdown;

export const Offer = ({ offer, selectedOffer, setSelectedOffer }) => {
  const { offerCode, offerAmount, offerDescription } = offer;

  const copyCode = code => {
    navigator.clipboard.writeText(code);
  };

  return (
    <div className="cardContainer" key={offerCode}>
      <div className="amount">
        &#8377;{offerAmount} <span className="offText">off</span>
      </div>
      <div className="descriptionText">{offerDescription}</div>
      <div className="makeFlex codeContainer">
        <div className="offerCode">{offerCode}</div>
        <div
          className="copyCallout"
          onClick={() => {
            setSelectedOffer(offerCode);
            copyCode(offerCode);
          }}
        >
          {selectedOffer === offerCode ? 'CODE COPIED' : 'COPY CODE'}
        </div>
      </div>
    </div>
  );
};
